var map = {
	"./bolo_thumb/1macaxeira.webp": 5651,
	"./bolo_thumb/1milho.webp": 7449,
	"./bolo_thumb/1pacoca.webp": 8989,
	"./bolo_thumb/bolobanana.webp": 9317,
	"./bolo_thumb/bolobananasemacucar.webp": 7740,
	"./bolo_thumb/bololimao.webp": 9377,
	"./bolo_thumb/bolomaca.webp": 6668,
	"./bolo_thumb/cenoura.webp": 5491,
	"./bolo_thumb/chocolate.webp": 1416,
	"./bolo_thumb/churros.webp": 1073,
	"./bolo_thumb/goiabada.webp": 3044,
	"./bolo_thumb/laranja.webp": 3848,
	"./bolo_thumb/ninho.webp": 1743,
	"./bolo_thumb/noiva.webp": 1504,
	"./junino_thumb/macaxeira.webp": 8925,
	"./junino_thumb/milho.webp": 4759,
	"./junino_thumb/pacoca.webp": 9489,
	"./torta_thumb/alema.webp": 7951,
	"./torta_thumb/alema_amendoim.webp": 1857,
	"./torta_thumb/alema_branca.webp": 9780,
	"./torta_thumb/alema_nozes.webp": 2065,
	"./torta_thumb/alema_ovomaltine.webp": 6753,
	"./torta_thumb/alema_sem_acucar.webp": 6061,
	"./torta_thumb/ameixa.webp": 6790,
	"./torta_thumb/amendoim_sem_acucar.webp": 9576,
	"./torta_thumb/banana.webp": 3267,
	"./torta_thumb/banoffee.webp": 1741,
	"./torta_thumb/bombonzao.webp": 8183,
	"./torta_thumb/brigadeiro.webp": 58,
	"./torta_thumb/brownie.webp": 4105,
	"./torta_thumb/brownie_morango.webp": 2275,
	"./torta_thumb/cafe.webp": 7354,
	"./torta_thumb/caramelo.webp": 321,
	"./torta_thumb/cheesecake.webp": 3699,
	"./torta_thumb/cheesecake_goiaba.webp": 430,
	"./torta_thumb/cheesecake_nutella.webp": 4749,
	"./torta_thumb/cheesecake_sem_acucar.webp": 5555,
	"./torta_thumb/chocolatra.webp": 2001,
	"./torta_thumb/damasco.webp": 464,
	"./torta_thumb/docedelicia.webp": 8742,
	"./torta_thumb/domino.webp": 4382,
	"./torta_thumb/donaana.webp": 9951,
	"./torta_thumb/feitico.webp": 6476,
	"./torta_thumb/gabriela.webp": 5353,
	"./torta_thumb/limao.webp": 6532,
	"./torta_thumb/maca.webp": 4174,
	"./torta_thumb/maracuja.webp": 3574,
	"./torta_thumb/menta.webp": 7200,
	"./torta_thumb/mesclada.webp": 9307,
	"./torta_thumb/morango.webp": 6605,
	"./torta_thumb/mousse.webp": 7064,
	"./torta_thumb/mousse_brigadeiro.webp": 998,
	"./torta_thumb/mousse_sem_acucar.webp": 5625,
	"./torta_thumb/nozes.webp": 5551,
	"./torta_thumb/paodemel.webp": 4216,
	"./torta_thumb/pontanegra.webp": 1775,
	"./torta_thumb/profiterolis.webp": 1927,
	"./torta_thumb/redvelvet.webp": 4627,
	"./torta_thumb/romeu.webp": 6004,
	"./torta_thumb/seducao.webp": 7588,
	"./torta_thumb/spumone.webp": 4991,
	"./torta_thumb/tentacao.webp": 2549,
	"./torta_thumb/tropical.webp": 355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6278;